<div class="panelbar-wrapper">
    <kendo-panelbar>
        <kendo-panelbar-item [title]="'EHS'" expanded="true" *ngIf="globals.hseUser">
            <ng-template kendoPanelBarContent>
                <div kendoRippleContainer style="width: 100%; height: 100%; padding: 15px;" class="container-fluid">
                    <fieldset>
                        <legend>Personal Safety</legend>
                        <label class="offshore-label">*** Offshore Data Only ***</label>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Current Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_CurrentYear" placeholder="Current Year" value=""
                                    disabled />
                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Current year injury count:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_Injury_CurrentYearValue_Offshore"
                                    placeholder="Total # Offshore Injuries this year" value="" />
                            </div>

                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Last year injury count:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_Injury_LastYearValue_Offshore" placeholder="Total # Offshore Injuries last year"
                                    value="" />
                            </div>
                        </div>
                    </fieldset>
                    <hr>
                    <fieldset>

                        <legend>Injury Free Days</legend>
                        <label class="offshore-label">*** Offshore Data Only ***</label>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Date of Last Injury:
                            </div>
                            <div class="col-sm-3 cell">
                                <kendo-datepicker style="width:100%"
                                    [(ngModel)]="myDate" [format]="'dd-MMM-yyyy'"
                                    (valueChange)="onDateChange($event)"
                                    placeholder="Date of last injury">
                                </kendo-datepicker>
                                <!-- <kendo-datepicker style="width:100%"
                                    [(ngModel)]="graphData.ehs_InjuryDays_LastDate_Offshore" [format]="'dd-MMM-yyyy'"
                                    placeholder="Date of last injury">
                                </kendo-datepicker> -->
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Best Performance to date:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_InjuryDays_BestPerformanceOffshore"
                                    placeholder="Best injury free days performance to date" value="" />
                            </div>
                        </div>
                    </fieldset>
                    <hr>
                    <fieldset>
                        <legend>Process Safety</legend>
                        <label class="offshore-label">*** Offshore Data Only ***</label>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label" >
                                YTD count:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_Process_CurrentYearValue_Offshore"
                                    placeholder="YTD count" value="" />
                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Last year count:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ehs_Process_LastYearValue_Offshore"
                                    placeholder="Last year count" value="" />
                            </div>
                        </div>
                    </fieldset>
                    <hr>
                    <fieldset>
                        <legend>Apply EHS</legend>                        
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3" >
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="saveEhs()" [icon]="'save EHS'" primary="false"
                                    title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelEhs()" [icon]="'cancel'" primary="false"
                                    title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </ng-template>
        </kendo-panelbar-item>

        <kendo-panelbar-item [title]="'Operational'" expanded="true" *ngIf="globals.opsUser">
            <ng-template kendoPanelBarContent>
                <div kendoRippleContainer style="width: 100%; height: 100%; padding: 15px;" class="container-fluid">

                    <fieldset>
                        <legend>Month</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Month:
                            </div>
                            <div class="col-sm-3 cell">
                                <kendo-dropdownlist [data]="listItems" [(ngModel)]="monthData.currentMonthName">
                                </kendo-dropdownlist>
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_CurrentYear" placeholder="Current Year" value="" />

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="saveOpsMonth()" [icon]="'save month'" primary="false"
                                    title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelOpsMonth()" [icon]="'cancel'" primary="false"
                                    title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Production Volumes By Area</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Onshore EA:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdArea_OnshoreEA" placeholder="Onshore EA" value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Offshore WA:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdArea_OffshoreWA" placeholder="Offshore WA"
                                    value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Offshore NA:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdArea_OffshoreNA" placeholder="Offshore NA"
                                    value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                PNG:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdArea_PNG" placeholder="PNG" value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Maximum Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdArea_Max" placeholder="Maximum Value" value="" />
                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotOperationalProductionAreaChart()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveOpsProductionArea()" [icon]="'save month'"
                                    primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelOpsProductionArea()" [icon]="'cancel'"
                                    primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>

                        <div class="row" style="padding-left:10px;margin-left: 20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-ops-onshore-offshore-production-volume
                                    ops_CurrentMonth={{graphData.ops_CurrentMonth}}
                                    ops_CurrentYear={{graphData.ops_CurrentYear}}
                                    ops_ProdArea_OffshoreNA={{graphData.ops_ProdArea_OffshoreNA}}
                                    ops_ProdArea_OffshoreWA={{graphData.ops_ProdArea_OffshoreWA}}
                                    ops_ProdArea_OnshoreEA={{graphData.ops_ProdArea_OnshoreEA}}
                                    ops_ProdArea_PNG={{graphData.ops_ProdArea_PNG}}
                                    ops_ProdArea_Max={{graphData.ops_ProdArea_Max}}
                                    ops_CurrentMonthName={{monthData.currentMonthName}}>
                                </app-ops-onshore-offshore-production-volume>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Production Volumes By Type</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Gas:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdType_Domgas" placeholder="Gas" value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Liquids:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdType_Liquids" placeholder="Liquids" value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                LNG:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdType_LNG" placeholder="LNG" value="" />
                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Maximum Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_ProdType_Max" placeholder="Maximum Value" value="" />
                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotOperationalProductionTypeChart()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveOpsProductionType()" [icon]="'save month'"
                                    primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelOpsProductionType()" [icon]="'cancel'"
                                    primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>

                        <div class="row" style="padding-left:10px;margin-left:20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-ops-onshore-offshore-production-type
                                    ops_CurrentMonth={{graphData.ops_CurrentMonth}}
                                    ops_CurrentYear={{graphData.ops_CurrentYear}}
                                    ops_ProdType_Domgas={{graphData.ops_ProdType_Domgas}}
                                    ops_ProdType_Liquids={{graphData.ops_ProdType_Liquids}}
                                    ops_ProdType_LNG={{graphData.ops_ProdType_LNG}}
                                    ops_ProdType_Max={{graphData.ops_ProdType_Max}}
                                    ops_CurrentMonthName={{monthData.currentMonthName}}>
                                </app-ops-onshore-offshore-production-type>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Wells Drilled & Connected</legend>
                        <div class="grid-container">
                            <div class="grid-item"></div>
                            <div class="grid-item1">COOPER</div>
                            <div class="grid-item1">GLNG</div>
                            <div class="grid-item">Drilled Target:</div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Target"
                                    placeholder="Drilled Cooper Target" value="" />
                            </div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Target" placeholder="Drilled GLNG Target"
                                    value="" />
                            </div>
                            <div class="grid-item">Drilled LastYear:</div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_LastYear"
                                    placeholder="Drilled Cooper LastYear" value="" />
                            </div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_LastYear"
                                    placeholder="Drilled GLNG LastYear" value="" />
                            </div>
                            <div class="grid-item">Drilled Jan:</div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Jan" placeholder="Drilled Cooper Jan"
                                    value="" />
                            </div>
                            <div class="grid-item">
                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Jan" placeholder="Drilled GLNG Jan"
                                    value="" />
                            </div>
                            <div class="grid-item">Drilled Feb:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Feb" placeholder="Drilled Cooper Feb"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Feb" placeholder="Drilled GLNG Feb"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled March:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Mar" placeholder="Drilled Cooper Mar"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Mar" placeholder="Drilled GLNG Mar"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled April:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Apr" placeholder="Drilled Cooper Apr"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Apr" placeholder="Drilled GLNG Apr"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled May:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_May" placeholder="Drilled Cooper May"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_May" placeholder="Drilled GLNG May"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled June:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Jun" placeholder="Drilled Cooper Jun"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Jun" placeholder="Drilled GLNG Jun"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled July:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Jul" placeholder="Drilled Cooper July"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Jul" placeholder="Drilled GLNG July"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled Aug:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Aug" placeholder="Drilled Cooper Aug"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Aug" placeholder="Drilled GLNG Aug"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled September:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Sep" placeholder="Drilled Cooper Sep"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Sep" placeholder="Drilled GLNG Sep"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled October:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Oct" placeholder="Drilled Cooper Oct"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Oct" placeholder="Drilled GLNG Oct"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled November:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Nov" placeholder="Drilled Cooper Nov"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Nov" placeholder="Drilled GLNG Nov"
                                    value="" />
                            </div>

                            <div class="grid-item">Drilled December:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Cooper_Dec" placeholder="Drilled Cooper Dec"
                                    value="" />

                            </div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_GLNG_Dec" placeholder="Drilled GLNG Dec"
                                    value="" />
                            </div>
                            <div class="grid-item">Drilled Max:</div>
                            <div class="grid-item">

                                <input kendoTextBox type="number" style="width: 100%"
                                    [(ngModel)]="graphData.ops_Drilled_Max" placeholder="Drilled Maximum value"
                                    value="" />

                            </div>
                            <div class="grid-item"></div>

                            <div class="grid-item">Connected Sub-heading:</div>
                            <div class="grid-item">

                                <textarea kendoTextArea type="string" [autoSize]="true" style="width: 209%;"
                                    [(ngModel)]="graphData.ops_Drilled_SubHeading" placeholder="Connected Sub-heading"
                                    value="">
                                </textarea>
                            </div>

                        </div>

                        <br>

                        <div class="row">
                            <div class="col-sm-5">
                            </div>
                            <div class="col-sm-7">
                                <button kendoButton (click)="plotOpsWellsDrilledandConnectedGraph()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveOpsWellsDrilledandConnectedData()"
                                    [icon]="'save month'" primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelOpsWellsDrilledandConnectedData()" [icon]="'cancel'"
                                    primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>

                        <br>

                        <div class="row" style="padding-left:10px;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-ops-wells-drilled-and-connected
                                    ops_Drilled_Cooper_Target={{graphData.ops_Drilled_Cooper_Target}}
                                    ops_Drilled_Cooper_LastYear={{graphData.ops_Drilled_Cooper_LastYear}}
                                    ops_Drilled_Cooper_Jan={{graphData.ops_Drilled_Cooper_Jan}}
                                    ops_Drilled_Cooper_Feb={{graphData.ops_Drilled_Cooper_Feb}}
                                    ops_Drilled_Cooper_Mar={{graphData.ops_Drilled_Cooper_Mar}}
                                    ops_Drilled_Cooper_Apr={{graphData.ops_Drilled_Cooper_Apr}}
                                    ops_Drilled_Cooper_May={{graphData.ops_Drilled_Cooper_May}}
                                    ops_Drilled_Cooper_Jun={{graphData.ops_Drilled_Cooper_Jun}}
                                    ops_Drilled_Cooper_Jul={{graphData.ops_Drilled_Cooper_Jul}}
                                    ops_Drilled_Cooper_Aug={{graphData.ops_Drilled_Cooper_Aug}}
                                    ops_Drilled_Cooper_Sep={{graphData.ops_Drilled_Cooper_Sep}}
                                    ops_Drilled_Cooper_Oct={{graphData.ops_Drilled_Cooper_Oct}}
                                    ops_Drilled_Cooper_Nov={{graphData.ops_Drilled_Cooper_Nov}}
                                    ops_Drilled_Cooper_Dec={{graphData.ops_Drilled_Cooper_Dec}}
                                    ops_Drilled_GLNG_Target={{graphData.ops_Drilled_GLNG_Target}}
                                    ops_Drilled_GLNG_LastYear={{graphData.ops_Drilled_GLNG_LastYear}}
                                    ops_Drilled_GLNG_Jan={{graphData.ops_Drilled_GLNG_Jan}}
                                    ops_Drilled_GLNG_Feb={{graphData.ops_Drilled_GLNG_Feb}}
                                    ops_Drilled_GLNG_Mar={{graphData.ops_Drilled_GLNG_Mar}}
                                    ops_Drilled_GLNG_Apr={{graphData.ops_Drilled_GLNG_Apr}}
                                    ops_Drilled_GLNG_May={{graphData.ops_Drilled_GLNG_May}}
                                    ops_Drilled_GLNG_Jun={{graphData.ops_Drilled_GLNG_Jun}}
                                    ops_Drilled_GLNG_Jul={{graphData.ops_Drilled_GLNG_Jul}}
                                    ops_Drilled_GLNG_Aug={{graphData.ops_Drilled_GLNG_Aug}}
                                    ops_Drilled_GLNG_Sep={{graphData.ops_Drilled_GLNG_Sep}}
                                    ops_Drilled_GLNG_Oct={{graphData.ops_Drilled_GLNG_Oct}}
                                    ops_Drilled_GLNG_Nov={{graphData.ops_Drilled_GLNG_Nov}}
                                    ops_Drilled_GLNG_Dec={{graphData.ops_Drilled_GLNG_Dec}}
                                    ops_Drilled_Max={{graphData.ops_Drilled_Max}}
                                    ops_Drilled_SubHeading={{graphData.ops_Drilled_SubHeading}}
                                    (drilled_SubHeading)='displaySubHeading($event)'>
                                </app-ops-wells-drilled-and-connected>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Exploration & Drilling Milestones</legend>
                        <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                            <app-ops-exploration_wells>
                            </app-ops-exploration_wells>
                        </p>
                        <br>
                        <div class="row">
                            <div class="col-sm-12">
                                <button kendoButton (click)="saveOpsExplorationAndDrillingMilestonesData()"
                                    [icon]="'save'" primary="false" title="Save" style="margin-left:15%;">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelOpsExplorationAndDrillingMilestonesData()"
                                    [icon]="'cancel'" primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <br>
                    </fieldset>
                </div>
            </ng-template>
        </kendo-panelbar-item>


        <kendo-panelbar-item [title]="'Financial'" expanded="true" *ngIf="globals.finUser">
            <ng-template kendoPanelBarContent>
                <div kendoRippleContainer style="width: 100%; height: 100%; padding: 15px;" class="container-fluid">
                    <fieldset>
                        <legend>Sales Revenue ($ million)</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Quarter:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="initialRevQuarter" (input)="inputQuarter(initialRevQuarter)"
                                    placeholder="Initial Quarter" title="Quarter value must be less than or equal 4"
                                    value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="2018" max="2030"
                                    [(ngModel)]="initialRevYear" (input)="inputYear(initialRevYear)"
                                    placeholder="Initial Year" title="Year must be in the range 2018-2030" value="" />
                            </div>

                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <hr style="width:50%;margin-left:20%;">
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Revenue_Name1}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Revenue_1"
                                    placeholder="Financial Revenue Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Revenue_Name2}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Revenue_2"
                                    placeholder="Financial Revenue Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Revenue_Name3}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Revenue_3"
                                    placeholder="Financial Revenue Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Revenue_Name4}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Revenue_4"
                                    placeholder="Financial Revenue Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Max Revenue Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Revenue_Max" placeholder="Max Sales Revenue Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotFinancialSalesRevenueChart()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveFinancialSalesRevenue()" [icon]="'save'"
                                    primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelFinancialSalesRevenue()" [icon]="'cancel'"
                                    primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <br>
                        <div class="row" style="padding-left:10px;margin-left: 20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-fin-sales-revenue fin_Revenue_Name1={{graphData.fin_Revenue_Name1}}
                                    fin_Revenue_Name2={{graphData.fin_Revenue_Name2}}
                                    fin_Revenue_Name3={{graphData.fin_Revenue_Name3}}
                                    fin_Revenue_Name4={{graphData.fin_Revenue_Name4}}
                                    fin_Revenue_1={{graphData.fin_Revenue_1}} fin_Revenue_2={{graphData.fin_Revenue_2}}
                                    fin_Revenue_3={{graphData.fin_Revenue_3}} fin_Revenue_4={{graphData.fin_Revenue_4}}
                                    fin_Revenue_Max={{graphData.fin_Revenue_Max}}
                                    (fin_Revenue_Quarter)='displayQuarter($event)'
                                    (fin_Revenue_Year)='displayYear($event)' initialYear={{initialRevYear}}
                                    (revenueName1)='displayrevenueName1($event)'
                                    (revenueName2)='displayrevenueName2($event)'
                                    (revenueName3)='displayrevenueName3($event)'
                                    (revenueName4)='displayrevenueName4($event)'>
                                </app-fin-sales-revenue>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Upstream Unit Production Cost ($/boe)</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Quarter:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="finCostInitialQuarter"
                                    (input)="prodCostInputQuarter(finCostInitialQuarter)" placeholder="Initial Quarter"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="2018" max="2030"
                                    [(ngModel)]="finCostInitialYear" (input)="prodCostInputYear(finCostInitialYear)"
                                    placeholder="Initial Year" title="Year must be in the range 2018-2030" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <hr style="width:50%;margin-left:20%;">
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cost_Name1}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cost_1"
                                    placeholder="Financial Unit Production Cost Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cost_Name2}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cost_2"
                                    placeholder="Financial Unit Production Cost Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cost_Name3}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cost_3"
                                    placeholder="Financial Unit Production Cost Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>

                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cost_Name4}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cost_4"
                                    placeholder="Financial Unit Production Cost Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Maximum Unit Prod Cost Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cost_Max"
                                    placeholder="Maximum Upstream Unit Production Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotFinancialUpstreamUnitProductionCostChart()"
                                    primary="false" title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveFinancialUpstreamUnitProductionCost()"
                                    [icon]="'save month'" primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelFinancialUpstreamUnitProductionCost()"
                                    [icon]="'cancel'" primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <br>
                        <div class="row" style="padding-left:10px;margin-left: 20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-fin-upstream-unit-production-cost fin_Cost_Name1={{graphData.fin_Cost_Name1}}
                                    fin_Cost_Name2={{graphData.fin_Cost_Name2}}
                                    fin_Cost_Name3={{graphData.fin_Cost_Name3}}
                                    fin_Cost_Name4={{graphData.fin_Cost_Name4}} fin_Cost_1={{graphData.fin_Cost_1}}
                                    fin_Cost_2={{graphData.fin_Cost_2}} fin_Cost_3={{graphData.fin_Cost_3}}
                                    fin_Cost_4={{graphData.fin_Cost_4}} fin_Cost_Max={{graphData.fin_Cost_Max}}
                                    (fin_Cost_Quarter)='costDisplayQuarter($event)'
                                    (fin_Cost_Year)='costDisplayYear($event)' finInitialYear={{finCostInitialYear}}
                                    (unitProdCostName1)='displayUnitProdCostName1($event)'
                                    (unitProdCostName2)='displayUnitProdCostName2($event)'
                                    (unitProdCostName3)='displayUnitProdCostName3($event)'
                                    (unitProdCostName4)='displayUnitProdCostName4($event)'>
                                </app-fin-upstream-unit-production-cost>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Free Cash Flow ($ million)</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Quarter:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="finFreeCashFlowInitialQuarter"
                                    (input)="cashInputQuarter(finFreeCashFlowInitialQuarter)"
                                    placeholder="Initial Quarter" title="Quarter value must be less than or equal 4"
                                    value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="2018" max="2030"
                                    [(ngModel)]="finFreeCashFlowInitialYear"
                                    (input)="cashInputYear(finFreeCashFlowInitialYear)" placeholder="Initial Year"
                                    title="Year must be in the range 2018-2030" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <hr style="width:50%;margin-left:20%;">
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cash_Name1}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cash_1"
                                    placeholder="Financial Free Cash Flow Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cash_Name2}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cash_2"
                                    placeholder="Financial Free Cash Flow Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cash_Name3}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cash_3"
                                    placeholder="Financial Free Cash Flow Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Cash_Name4}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cash_4"
                                    placeholder="Financial Free Cash Flow Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Maximum Free Cash Flow Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Cash_Max" placeholder="Maximum Free Cash Flow Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotFinancialFreeCashFlowChart()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveFinancialFreeCashFlow()" [icon]="'save month'"
                                    primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelFinancialFreeCashFlow()" [icon]="'cancel'"
                                    primary="false" title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <br>
                        <div class="row" style="padding-left:10px;margin-left: 20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-fin-free-cash-flow fin_Cash_Name1={{graphData.fin_Cash_Name1}}
                                    fin_Cash_Name2={{graphData.fin_Cash_Name2}}
                                    fin_Cash_Name3={{graphData.fin_Cash_Name3}}
                                    fin_Cash_Name4={{graphData.fin_Cash_Name4}} fin_Cash_1={{graphData.fin_Cash_1}}
                                    fin_Cash_2={{graphData.fin_Cash_2}} fin_Cash_3={{graphData.fin_Cash_3}}
                                    fin_Cash_4={{graphData.fin_Cash_4}} fin_Cash_Max={{graphData.fin_Cash_Max}}
                                    (fin_Cash_Quarter)='freeCashFlowDisplayQuarter($event)'
                                    (fin_Cash_Year)='freeCashFlowDisplayYear($event)'
                                    finCashFlowInitialYear={{finFreeCashFlowInitialYear}}
                                    (freeCashFlowName1)='displayFreeCashFlowName1($event)'
                                    (freeCashFlowName2)='displayFreeCashFlowName2($event)'
                                    (freeCashFlowName3)='displayFreeCashFlowName3($event)'
                                    (freeCashFlowName4)='displayFreeCashFlowName4($event)'>
                                </app-fin-free-cash-flow>
                            </p>
                        </div>
                    </fieldset>

                    <hr>

                    <fieldset>
                        <legend>Gearing (%)</legend>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Quarter:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="finInitialQuarterGearing"
                                    (input)="gearingInputQuarter(finInitialQuarterGearing)"
                                    placeholder="Initial Quarter" title="Quarter value must be less than or equal 4"
                                    value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Initial Year:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="2018" max="2030"
                                    [(ngModel)]="finInitialYearGearing"
                                    (input)="gearingInputYear(finInitialYearGearing)" placeholder="Initial Year"
                                    title="Year must be in the range 2018-2030" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <hr style="width:50%;margin-left:20%;">
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Gearing_Name1}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Gearing_1"
                                    placeholder="Financial Gearing Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Gearing_Name2}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Gearing_2"
                                    placeholder="Financial Gearing Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Gearing_Name3}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Gearing_3"
                                    placeholder="Financial Gearing Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                {{this.graphData.fin_Gearing_Name4}}:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Gearing_4"
                                    placeholder="Financial Gearing Current Quarter Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>

                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3 label">
                                Maximum Gearing Value:
                            </div>
                            <div class="col-sm-3 cell">
                                <input kendoTextBox type="number" style="width: 100%" min="1" max="4"
                                    [(ngModel)]="graphData.fin_Gearing_Max" placeholder="Maximum Gearing Value"
                                    title="Quarter value must be less than or equal 4" value="" />
                            </div>
                            <div class="col-sm-3 label">

                            </div>
                            <div class="col-sm-3 cell">

                            </div>
                        </div>
                        <div class="row" style="margin-left:20%;">
                            <div class="col-sm-3">
                            </div>
                            <div class="col-sm-9">
                                <button kendoButton (click)="plotFinancialGearingGraph()" primary="false"
                                    title="Try">Try
                                </button>
                                &nbsp;
                                <button kendoButton (click)="saveFinancialGearing()" [icon]="'save month'"
                                    primary="false" title="Save">
                                    Save
                                </button>
                                &nbsp;
                                <button kendoButton (click)="cancelFinancialGearing()" [icon]="'cancel'" primary="false"
                                    title="Cancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <br>
                        <div class="row" style="padding-left:10px;margin-left: 20%;">
                            <p style="width: 100%; text-align: center; margin: 0px; border-style:none;">
                                <app-fin-gearing fin_Gearing_Name1={{graphData.fin_Gearing_Name1}}
                                    fin_Gearing_Name2={{graphData.fin_Gearing_Name2}}
                                    fin_Gearing_Name3={{graphData.fin_Gearing_Name3}}
                                    fin_Gearing_Name4={{graphData.fin_Gearing_Name4}}
                                    fin_Gearing_1={{graphData.fin_Gearing_1}} fin_Gearing_2={{graphData.fin_Gearing_2}}
                                    fin_Gearing_3={{graphData.fin_Gearing_3}} fin_Gearing_4={{graphData.fin_Gearing_4}}
                                    fin_Gearing_Max={{graphData.fin_Gearing_Max}}
                                    (fin_Gearing_Quarter)='gearingDisplayQuarter($event)'
                                    (fin_Gearing_Year)='gearingisplayYear($event)'
                                    finGearingInitialYear={{finInitialYearGearing}}
                                    (GearingName1)='displayGearingName1($event)'
                                    (GearingName2)='displayGearingName2($event)'
                                    (GearingName3)='displayGearingName3($event)'
                                    (GearingName4)='displayGearingName4($event)'>
                                </app-fin-gearing>
                            </p>
                        </div>
                    </fieldset>
                </div>
            </ng-template>
        </kendo-panelbar-item>
    </kendo-panelbar>
</div>